import { GridItem, useBreakpointValue } from '@chakra-ui/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { specialHealthCheckTypes } from '../../../../constants/code';
import { useFormItems } from '../../../../hooks/formItems';
import InformationItems, { ItemCommonProps } from './Information';
import { UserInfoState } from './UserInfoAccordion';

/**
 * 健診関連情報
 */
type HealthCheckupState = Pick<UserInfoState, 'workerReference'>;

/**
 * 健診関連情報
 * @param props - プロパティ
 * @returns
 */
const HealthCheckupInformation: React.FunctionComponent<ItemCommonProps> = (
  props
) => {
  const form = useFormContext<HealthCheckupState>();
  const { FormDatePicker, FormInput, FormInputNumber, FormSelect } =
    useFormItems<HealthCheckupState>(form);
  const emptyGridItemHidden = useBreakpointValue({ base: true, md: false });

  return (
    <InformationItems name="健診関連" panelIndex={3}>
      <GridItem margin={2}>
        <FormSelect
          label="血液型 (RH)"
          mode={props.mode}
          name="workerReference.bloodRhType"
          options={[{ value: 'RH+' }, { value: 'RH-' }]}
        />
      </GridItem>
      <GridItem margin={2}>
        <FormSelect
          label="血液型"
          mode={props.mode}
          name="workerReference.bloodType"
          options={[
            { value: 'A' },
            { value: 'B' },
            { value: 'AB' },
            { value: 'O' },
          ]}
        />
      </GridItem>
      <GridItem margin={2}>
        <FormInputNumber
          label="血圧 (最高)"
          mode={props.mode}
          name="workerReference.bloodPressureMax"
          numberInputProps={{ min: 0 }}
          numberInputStepperProps={{ hidden: true }}
        />
      </GridItem>
      <GridItem margin={2}>
        <FormInputNumber
          label="血圧 (最低)"
          mode={props.mode}
          name="workerReference.bloodPressureMin"
          numberInputProps={{ min: 0 }}
          numberInputStepperProps={{ hidden: true }}
        />
      </GridItem>
      <GridItem margin={2}>
        <FormDatePicker
          label="前回検診日"
          mode={props.mode}
          name="workerReference.lastHealthCheckDate"
          onClickClear={(name) => form.setValue(name, '')}
        />
      </GridItem>
      <GridItem hidden={emptyGridItemHidden} />
      <GridItem margin={2}>
        <FormDatePicker
          label="特殊健康診断日"
          mode={props.mode}
          name="workerReference.specialHealthCheckDate"
          onClickClear={(name) => form.setValue(name, '')}
        />
      </GridItem>
      <GridItem margin={2}>
        <FormSelect<number>
          label="特殊健診種類"
          mode={props.mode}
          name="workerReference.specialHealthCheckType"
          options={Object.entries(specialHealthCheckTypes).map(([k, v]) => ({
            value: parseInt(k),
            valueToDisplay: v,
          }))}
          valueConverter={parseInt}
        />
      </GridItem>
    </InformationItems>
  );
};

export default HealthCheckupInformation;
